<template>
    <div>
        <div class="dashboard_faculty_item">
            <div class="dashboard_faculty_item_left">
                <div class="as_link_grey dashboard_faculty_item_name"
                    @click="changeFaculty(faculty_data.faculty_data.id)">
                    {{ faculty_data.faculty_data.acronym }} - {{ faculty_data.faculty_data.name }}
                </div>
                <br><br>
                <div class="deadline_status" :class="deadlineStatus">{{ status_text }}</div>
                <div class="dashboard_faculty_item_progress">
                    Izpolnjeno: {{ faculty_data.faculty_fill_percent }}%
                </div>
            </div>

            <div class="dashboard_faculty_item_right">
                <!-- <div v-show="nextDeadlineTimestamp > 0" class="dashboard_faculty_item_deadline">
                    Naslednji rok: {{nextDeadline()}}
                </div> -->
                <div class="dashboard_toggle_section_list" @click="showSections = !showSections"
                    :class="{ 'active': showSections }" v-if="faculty_data.sections != null">
                    prikaži/skrij področja
                    <font-awesome-icon v-show="!showSections" :icon="['fas', 'angle-down']" />
                    <font-awesome-icon v-show="showSections" :icon="['fas', 'angle-up']" />
                </div>
            </div>
        </div>
        <transition name="expand" @after-enter="afterEnter" @enter="enter" @leave="leave">
            <div v-show="showSections" class="dashboard_section_list">
                <div class="dashboard_section_item" v-for="section in filteredRowBySections" :key="section.id">
                    <div class="dashboard_section_item_left">

                        <div class="as_link_grey dashboard_section_name"
                            @click="changeFacultySection({ data: { faculty_id: faculty_data.faculty_data.id, section_id: section.id } })">
                            {{ section.name }}</div>
                        <br>

                        <div v-if="section.submitted == 1" class="deadline_status filled">oddano</div>
                        <div v-else class="deadline_status"
                            :class="deadlineStatusSection(section.deadline, section.deadlineClosed).class">
                            {{ deadlineStatusSection(section.deadline, section.deadlineClosed).text }}</div>
                    </div>
                    <div class="dashboard_section_item_right">
                        <div class="dashboard_section_item_deadline">
                            <div v-if="section.submitted == 1">Oddano: {{ convertDateTime(section.submit_time) }}</div>
                            <div v-else>
                                Rok: {{ convertDate(section.deadline) }}
                                <br>
                                Zadnji rok: {{ convertDate(section.deadlineClosed) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
    name: 'SectionsDashboardFacultyListItem',
    data() {
        return {
            nextDeadlineTimestamp: 0,
            nextDeadlineClosedTimestamp: 0,
            status_text: '',
            showSections: false,
            nearDeadlineDays: 14
        };
    },
    props: {
        faculty_data: Object
    },
    computed: {
        deadlineStatus() {
            const now = Date.now();

            if (this.faculty_data.section_submitted_count === this.faculty_data.section_count)
                return 'filled';

            if (this.nextDeadlineClosedTimestamp > 0 && now > this.nextDeadlineClosedTimestamp)
                return 'after_late';

            if (this.nextDeadlineTimestamp > 0) {
                if (now > this.nextDeadlineTimestamp)
                    return 'after';
                if (now > this.nextDeadlineTimestamp - this.nearDeadlineDays * 86400000)
                    return 'preparation_late';
            }

            return 'preparation';
        },
        filteredRowBySections() {
            return Object.values(this.faculty_data.sections || {}).sort((a, b) =>
                parseInt(a.order_number) > parseInt(b.order_number) ? 1 : -1
            );
        }
    },
    watch: {
        deadlineStatus: {
            immediate: true,
            handler(newVal) {
                if (!this.faculty_data?.faculty_data?.id) return;

                this.status_text = {
                    filled: 'oddano',
                    after_late: 'zamujeno',
                    after: 'zamuda',
                    preparation_late: 'v pripravi',
                    preparation: 'v pripravi'
                }[newVal];

                this.dashboardAddLastStatusByFaculty({
                    id: this.faculty_data.faculty_data.id,
                    status: 'status_' + newVal
                });
            }
        }
    },
    mounted() {
        this.computeDeadlines();
    },
    methods: {
        ...mapActions(['dashboardAddLastStatusByFaculty', 'changeFaculty', 'changeFacultySection']),
        computeDeadlines() {
            const sections = Object.values(this.faculty_data.sections || []);
            this.nextDeadlineTimestamp = this.getMaxTimestamp(sections.map(s => s.deadline));
            this.nextDeadlineClosedTimestamp = this.getMaxTimestamp(sections.map(s => s.deadlineClosed));
        },
        getMaxTimestamp(dates) {
            const valid = dates.filter(d => d && d !== '0000-00-00').map(d => new Date(d).getTime());
            return valid.length ? Math.max(...valid) : 0;
        },
        convertDate(date) {
            return date === '0000-00-00' ? 'ni določen' : moment(date, 'YYYY-MM-DD').format('D. M. YYYY');
        },
        convertDateTime(datetime) {
            return datetime === '0000-00-00 00:00:00'
                ? 'ni določen'
                : moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('D. M. YYYY');
        },
        getDeadline() {
            if (!this.section_data?.deadline || this.section_data.deadline === '0000-00-00') return '';
            const date = new Date(this.section_data.deadline);
            this.deadlineTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },

        getDeadlineClosed() {
            if (!this.section_data?.deadlineClosed || this.section_data.deadlineClosed === '0000-00-00') return '';
            const date = new Date(this.section_data.deadlineClosed);
            this.deadlineClosedTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },
        deadlineStatusSection(deadline, deadlineClosed) {
            const now = Date.now();
            const ts = deadline !== '0000-00-00' ? new Date(deadline).getTime() : 0;
            const tsClosed = deadlineClosed !== '0000-00-00' ? new Date(deadlineClosed).getTime() : 0;

            if (tsClosed > 0 && now > tsClosed)
                return { class: 'after_late', text: 'zamujeno' };
            if (ts > 0) {
                if (now > ts) return { class: 'after', text: 'zamuda' };
                if (now > ts - this.nearDeadlineDays * 86400000)
                    return { class: 'preparation_late', text: 'v pripravi' };
            }
            return { class: 'preparation', text: 'v pripravi' };
        },
        afterEnter(el) {
            el.style.height = 'auto';
        },
        enter(el) {
            const { height } = getComputedStyle(el);
            el.style.height = '0';
            getComputedStyle(el).height;
            requestAnimationFrame(() => {
                el.style.height = height;
            });
        },
        leave(el) {
            const { height } = getComputedStyle(el);
            el.style.height = height;
            getComputedStyle(el).height;
            requestAnimationFrame(() => {
                el.style.height = '0';
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.expand-enter-active,
.expand-leave-active {
    transition: height 1s ease-in-out;
    overflow: hidden;
}

.expand-enter,
.expand-leave-to {
    height: 0;
}
</style>
